import { render, staticRenderFns } from "./EndElement.vue?vue&type=template&id=128bf1b9&scoped=true&"
import script from "./EndElement.vue?vue&type=script&lang=js&"
export * from "./EndElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128bf1b9",
  null
  
)

export default component.exports